import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import {
  GenericNavbarsStyles,
  inputGroup,
  variables,
} from "../../../../variables";
import PropTypes from "prop-types";
import { currencies, onEnterDown } from "../../../../helpers";
import EntityAutocomplete from "../../../../components/EntityAutocomplete";
import { CustomButton } from "../../../../components/CustomButton";

const approvedMapping = {
  "": "-----",
  true: "Yes",
  false: "No",
};

const navbarStyles = createUseStyles({
  Navbar: {
    ...GenericNavbarsStyles.navbars.mobile(),
    gridTemplateRows: "max-content max-content max-content max-content ",
  },
  label: { ...inputGroup },
  divider: GenericNavbarsStyles.divider.mobile(),
  filters: GenericNavbarsStyles.filters.mobile(),
  actions: GenericNavbarsStyles.actions.mobile(),
  inputGroup: {
    ...inputGroup,
    width: "100%",
    "& input, select": {
      ...inputGroup["& input, select"],
      width: "100%",
    },
  },
  inputGroupOneLine: {
    ...inputGroup,
    gridColumn: "2 span",
    width: "100%",
  },
  [`@media ${variables.media.smallscreen}`]: {
    Navbar: {
      ...GenericNavbarsStyles.navbars.smallscreen(),
      gridTemplateColumns: "repeat(2, max-content) 1fr max-content",
      gridTemplateRows: "max-content",
    },
    divider: GenericNavbarsStyles.divider.smallscreen(),
    filters: {
      ...GenericNavbarsStyles.filters.smallscreen(),
      gridTemplateColumns: "repeat(7, 1fr)",
    },
    actions: GenericNavbarsStyles.actions.smallscreen(),
    inputGroup: {
      ...inputGroup,
    },
    inputGroupOneLine: { ...inputGroup.bigscreen, gridColumn: "1 span" },
  },
  [`@media ${variables.media.retina}`]: {
    filters: {
      ...GenericNavbarsStyles.filters.smallscreen(),
      gridTemplateColumns: "repeat(6, 1fr)",
    },
  },
  [`@media ${variables.media.bigscreen}`]: {
    filters: {
      gridTemplateColumns: "repeat(7, 1fr)",
    },
  },
});

const Navbar = ({ filters, initialFilters, onApplyFilters, onAdd }) => {
  const classes = navbarStyles();

  const [localFilters, setLocalFilters] = useState(filters);
  const [autocompleteValue, setAutocompleteValue] = useState("");

  return (
    <div className={classes.Navbar}>
      <div className={classes.label}>
        <strong>Subagents</strong>
      </div>
      <div className={classes.divider}></div>
      <div className={classes.filters}>
        <div className={classes.inputGroupOneLine}>
          <label>Name</label>
          <input
            id="filterName"
            type="text"
            value={localFilters.name__icontains}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                name__icontains: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Subagent Source Entity</label>
          <EntityAutocomplete
            id={"filterSourceEntityId"}
            members={false}
            independentAgents={false}
            branches={false}
            value={autocompleteValue}
            setValue={setAutocompleteValue}
            onChange={(text) => {
              if (text.length === 0) {
                setLocalFilters((p) => ({
                  ...p,
                  id: "",
                }));
                return;
              }
              const entityInfos = text.split("---");
              const entityId = entityInfos[1];
              setLocalFilters((p) => ({
                ...p,
                id: `${entityId}`,
              }));
            }}
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Legal Title</label>
          <input
            id="filterLegalTitle"
            type="text"
            value={localFilters.legal_title__icontains}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                legal_title__icontains: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Tags</label>
          <input
            id="filter_tags"
            type="text"
            value={localFilters.tags}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                tags: e.target.value,
              }))
            }
            onKeyDown={(e) =>
              onEnterDown(e, onApplyFilters, localFilters)
            }></input>
        </div>
        <div className={classes.inputGroup}>
          <label>Currency</label>
          <select
            id="filterCurrency"
            value={localFilters.currency__icontains}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                currency__icontains: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}>
            {Object.entries(currencies).map(([value, label], idx) => (
              <option key={idx} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className={classes.inputGroup}>
          <label>E-mail</label>
          <input
            id="filterEmail"
            type="email"
            value={localFilters.email__icontains}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                email__icontains: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Minimum Completeness</label>
          <input
            id="filterCompleteness"
            type="number"
            value={localFilters.completeness__gte}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                completeness__gte: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>

        <div className={classes.inputGroup}>
          <label>Approved</label>
          <select
            id="filterApproved"
            value={localFilters.approved}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                approved: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}>
            {Object.entries(approvedMapping).map(([value, label], idx) => (
              <option key={idx} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className={classes.inputGroup}>
          <label>Created After</label>
          <input
            id="filterCreatedAfter"
            type="date"
            value={localFilters.created__gte}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                created__gte: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
        <div className={classes.inputGroup}>
          <label>Created Before</label>
          <input
            id="filterCreatedBefore"
            type="date"
            value={localFilters.created__lte}
            onChange={(e) =>
              setLocalFilters((p) => ({
                ...p,
                created__lte: e.target.value,
              }))
            }
            onKeyDown={(e) => onEnterDown(e, onApplyFilters, localFilters)}
          />
        </div>
      </div>
      <div className={classes.actions}>
        <CustomButton
          id="ResetFiltersButton"
          appearance="ghost"
          onClick={() =>
            setLocalFilters({
              ...initialFilters,
            })
          }>
          <strong>Reset</strong>
        </CustomButton>
        <CustomButton
          id="ApplyFiltersButton"
          appearance="primary"
          onClick={() => {
            onApplyFilters({
              ...localFilters,
            });
            setAutocompleteValue("");
          }}>
          <strong>Apply Filters</strong>
        </CustomButton>
        <div className={classes.divider} />
        <CustomButton id="addSubagentButton" appearance="ghost" onClick={onAdd}>
          <strong>Add</strong>
        </CustomButton>
      </div>
    </div>
  );
};
Navbar.propTypes = {
  filters: PropTypes.object.isRequired,
  initialFilters: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default Navbar;
